import { useQuery, useMutation, useQueryClient } from "react-query"
import { AxiosRequest } from "./"
import { toast } from "../utilities/MyCustomFile"
import 'react-toastify/dist/ReactToastify.css';

const fetchData = async (url) => {
    try {
        const response = await AxiosRequest({ url });
        return response.data?.status ? response.data : [];
    } catch (error) {
        console.warn(error);
        return error;
    }
};
export const useFetchData = (onSuccess, onError, url, newKey) => useQuery(newKey, () => fetchData(url), { onSuccess, onError, refetchOnMount: false })

const addNewData = async (data) => {
    return AxiosRequest({ url: data.url, method: 'post', data })
        .then(response => {
            const { status, message, auth_url, setDisable } = response.data || {}
            if (status) {
                toast.success(message); data.setOpen(); data.formik(); data.setSubmitting(); auth_url && window.open(auth_url, '_blank');
            } else { toast.error(message); setDisable && data?.setSubmitting() }
        })
}
export const useAddData = (newKey) => {
    const queryClient = useQueryClient()
    return useMutation(addNewData, {
        onSuccess: () => {
            queryClient.invalidateQueries(newKey)
        },
    })
}

const deleteData = async (param) => {
    const { id, url } = param
    return AxiosRequest({ url: `/${url}/${id}`, method: 'delete' })
        .then(response => response.data.status ? toast.success(response.data.message) : toast.error(response.data.message))
}
export const useDeleteData = (newKey) => {
    const queryClient = useQueryClient();
    return useMutation((val) => deleteData(val), {
        onSuccess: (_, val) => {
            queryClient.setQueryData(newKey, (oldQueryData) => {
                const updatedData = Array.isArray(oldQueryData) && oldQueryData.filter((item) => item[val.idKey] != val.id);
                return updatedData
            });
            queryClient.invalidateQueries(newKey);
        },
        onError: (error) => {
            console.error('Mutation error:', error);
        },
    });
};

const singleData = (param) => {
    const { id, url } = param
    return AxiosRequest({ url: `/${url}/${id}` })
}
export const useSingleData = (newKey) => {
    const queryClient = useQueryClient();
    return useMutation((val) => singleData(val), {
        onSuccess: () => {
            queryClient.invalidateQueries(newKey)
        },
    });
};

export const fetchOwnData = async ({ queryKey }) => {
    const [, id, url] = queryKey
    return AxiosRequest({ url: `${url}/${id}` })
}
export const useFetchOwnData = (url, id, newKey) => useQuery([newKey, id, url], fetchOwnData)

export const addLoginFun = async (data) => {
    const { url, email, email_otp, success, navigate, redirect } = data
    return AxiosRequest({ url, method: "post", data })
        .then(response => {
            if (response.data.status) {
                email_otp && sessionStorage.setItem("p_to", response.data.token)
                email_otp && sessionStorage.setItem("detail", JSON.stringify(response.data.message))
                navigate(redirect, { state: email_otp ? { message: response.data.message } : { email } })
                toast.success(success)
            } else {
                toast.error(response.data.message)
            }
        }).catch((error) => toast.error(error.response?.data.message))
}
export const useLoginFun = (newKey) => {
    const queryClient = useQueryClient()
    return useMutation(addLoginFun, {
        onSuccess: () => {
            queryClient.invalidateQueries(newKey)
        },
    })
}
// old format
export const getAPI = async (url) => {
    try {
        const {data} = await AxiosRequest({ url: `/api/v1/${url}` });
        // return data;
        return data?.status ? data : [];
    } catch (error) {
        if (error.response.status === 204) {
            return { status: false, message: [] }
        } else {
            toast.error(error.response?.data.message)
            return { status: false, message: [] }
        }
    }
}
export const postAPI = async (url, data) => {
    try {
        const response = await AxiosRequest({ url: `/api/v1/${url}`, method: 'post', data });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error('Server responded with an error:', error.response.data);
            throw new Error(error.response.data.message || 'Server Error');
        } else if (error.request) {
            console.error('No response received from the server');
            throw new Error('No response received from the server');
        } else {
            // console.error('Error setting up the request:', error.message);
            throw new Error('Request setup error');
        }
    }
};
export const putAPI = async (url, data) => {
    try {
        const response = await AxiosRequest({ url: `/api/v1/${url}`, method: 'put', data });
        if (response.data && response.data.status) {
            return response.data;
        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {
        if (error.response) {
            console.error('Server responded with an error:', error.response.data);
            throw new Error(error.response.data.message || 'Server Error');
        } else if (error.request) {
            console.error('No response received from the server');
            throw new Error('No response received from the server');
        } else {
            // console.error('Error setting up the request:', error.message);
            throw new Error('Request setup error');
        }
    }
};
export const deleteAPI = async (url, id) => {
    const response = await AxiosRequest({ url: `/api/v1/${url}/${id}`, method: 'delete' })
    return response.data
}
export const singleAPI = async (url, id) => {
    const response = await AxiosRequest({ url: `/api/v1/${url}/${id}` })
    return response.data
}